import f from 'odata-filter-builder';
import { transformODataResponse } from 'utilities/query';
import templateUrl from './map-categories.html';

export default {
  templateUrl,
  bindings: {
    flex: '@',
    layout: '@'
  },
  controller: class MapCategoriesComponent {
    constructor($mdDialog, $scope, MapCategoriesService, LoadingService, ToastService) {
      'ngInject';

      Object.assign(this, {
        $mdDialog,
        $scope,
        MapCategoriesService,
        LoadingService,
        ToastService
      });
    }

    $onInit() {
      this.columns = [{
        FieldName: 'ProductName',
        DisplayName: 'Product Name'
      }, {
        FieldName: 'MapCount',
        DisplayName: 'Map Count'
      }];

      this.query = {
        ...this.MapCategoriesService.getProductQuery()
      };

      this.queryMapped = {
        ...this.MapCategoriesService.getProductQuery()
      };

      this.selectedProducts = [];
      this.selectedMappedProducts = [];
      this.mappedProducts = [];
      this.categories = [];
    }

    refreshResults() {
      const promises = [
        this.refreshProducts(),
        this.refreshMappedProducts()
      ];

      Promise.all(promises);
    }

    refreshProducts() {
      this.selectedProducts = [];
      this.selectedMappedProducts = [];

      let filter = f().eq('ProductCategoryId', this.selectedCategory.ProductCategoryId)
        .and(x => x.eq('IsMapped', 0));

      if (this.productSearchText && this.productSearchText.length) {
        filter = filter.and(x => x.contains('ProductName', this.productSearchText));
      }

      this.promise = this.MapCategoriesService.searchProducts({
        ...this.query,
        filter
      });

      return this.promise.then((r) => {
        this.products = transformODataResponse(r);
      }).catch(error => this.ToastService.showError(error));
    }

    refreshMappedProducts() {
      this.selectedMappedProducts = [];

      let filter = f().eq('ProductCategoryId', this.selectedCategory.ProductCategoryId)
        .and(x => x.eq('IsMapped', 1));

      if (this.mappedProductSearchText && this.mappedProductSearchText.length) {
        filter = filter.and(x => x.contains('ProductName', this.mappedProductSearchText));
      }

      this.promiseMapped = this.MapCategoriesService.searchProducts({
        ...this.queryMapped,
        filter
      });

      return this.promiseMapped.then((r) => {
        this.mappedProducts = transformODataResponse(r);
      }).catch(error => this.ToastService.showError(error));
    }

    selectedCategoryChanged({ selectedItem }) {
      this.selectedCategory = selectedItem;

      if (selectedItem) {
        this.refreshResults();
      } else {
        this.products = [];
        this.mappedProducts = [];
        this.productSearchText = null;
        this.mappedProductSearchText = null;
      }
    }

    addMapping(selectedCategory, selectedProducts) {
      this.LoadingService.start();
      const productIds = selectedProducts.map(p => p.ProductId);

      this.MapCategoriesService
        .addProductCategoryMapping(selectedCategory.ProductCategoryId, productIds)
        .then(() => {
          this.selectedProducts = [];

          const promises = [
            this.refreshProducts(),
            this.refreshMappedProducts()
          ];

          Promise.all(promises).then(() => this.ToastService.showSuccess('Product categories mapped successfully!'));
        })
        .catch(error => this.ToastService.showError(error))
        .finally(() => this.LoadingService.stop());
    }

    removeMapping(selectedCategory, selectedProducts) {
      this.LoadingService.start();
      const productIds = selectedProducts.map(p => p.ProductId);

      this.MapCategoriesService
        .removeProductCategoryMapping(selectedCategory.ProductCategoryId, productIds)
        .then(() => {
          this.selectedMappedProducts = [];

          const promises = [
            this.refreshProducts(),
            this.refreshMappedProducts()
          ];

          Promise.all(promises).then(() => this.ToastService.showSuccess('Product categories unmapped successfully!'));
        })
        .catch(error => this.ToastService.showError(error))
        .finally(() => this.LoadingService.stop());
    }

    onProductSearchTextChanged({ searchText }) {
      this.selectedProducts = [];
      this.productSearchText = searchText;
      this.refreshProducts();
    }

    onQueryChanged({ query }) {
      this.selectedProducts = [];
      this.query = query;
      this.refreshProducts();
    }

    onMappedProductSearchTextChanged({ searchText }) {
      this.selectedMappedProducts = [];
      this.mappedProductSearchText = searchText;
      this.refreshMappedProducts();
    }

    onMappedQueryChanged({ query }) {
      this.selectedMappedProducts = [];
      this.queryMapped = query;
      this.refreshMappedProducts();
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/map-categories/map-categories.component.js